export default "src/content/themes/association-wordpress-theme/img/bd02dddce6ebb227ad569b878b1f2d18.jpg";